import React from "react";
import {
  ExternalLink,
  MessageSquare,
  TrendingUp,
  Users,
  Trophy,
  Sparkles,
} from "lucide-react";

const ICONS = {
  demand: TrendingUp,
  competitors: Users,
  reddit: MessageSquare,
  earnings: Trophy,
  social: Sparkles,
  highlight: Sparkles,
  source: ExternalLink,
};

const LABELS = {
  demand: "Demand Signal",
  competitors: "Competitor",
  reddit: "Real People (Reddit)",
  earnings: "Earnings Report",
  social: "Social Proof",
  highlight: "Highlight Source",
  source: "Source",
};

// `sources` may be either the legacy all_sources shape (no idx) OR the
// new numbered_sources shape (with idx). Prefer numbered if it has idx.
export default function SourcesList({ sources = [] }) {
  const list = (sources || []).filter((s) => s && s.url);
  if (list.length === 0) {
    return (
      <div className="gl-card text-sm text-[#b6c1b8]">
        No external sources captured for this run.
      </div>
    );
  }
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 gap-3"
      data-testid="sources-list"
    >
      {list.slice(0, 18).map((s, i) => {
        const Icon = ICONS[s.type] || ExternalLink;
        const num = s.idx || i + 1;
        return (
          <a
            key={`${s.url}-${num}`}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`source-${num}`}
            className="gl-card-lift p-4 flex flex-col gap-2 group"
          >
            <div className="flex items-center gap-2">
              <span
                className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#4ADE80]/12 text-[#4ADE80] text-[11px] font-bold tabular-nums border border-[#4ADE80]/30"
                aria-label={`Footnote ${num}`}
              >
                {num}
              </span>
              <Icon size={13} className="text-[#4ADE80]" />
              <span className="gl-label text-[10px]">{LABELS[s.type] || "Source"}</span>
            </div>
            <div className="text-sm text-white font-medium leading-snug line-clamp-2">
              {s.title || s.url}
            </div>
            {s.snippet ? (
              <div className="text-xs text-[#b6c1b8] line-clamp-2">{s.snippet}</div>
            ) : null}
            <div className="flex items-center gap-1 text-xs text-[#4ADE80] mt-auto truncate">
              <span className="truncate max-w-[260px]">{s.url}</span>
              <ExternalLink size={12} />
            </div>
          </a>
        );
      })}
    </div>
  );
}
